<script>
  import { urlServeur, tabCouleurAugmentation } from "../components/conf.js";
  import Spinner from "../components/ToolsSpinner.svelte";

  let promise;
  let les_annees;
  const fetchAgmentation = async () => {
    const response = await fetch(urlServeur + "/api_employe/sal_augmentation");
    if (response.ok) {
      const res = await response.json();
      //console.log(res.payload);
      les_annees = res.payload.liste_tab_annee;
      return res.payload.augmentation;
    }
  };

  const couleurAug = (couleur) => {
    if (couleur > 3) {
      couleur = 4;
    }
    return tabCouleurAugmentation[couleur];
  };

  promise = fetchAgmentation();
</script>

{#await promise}
  <Spinner />
{:then elements}
  <div class="row">
    <div class="col-sm-12">
      <h6>Augmentations des 5 dernières années</h6>
      <table class="table table-responsive table-sm">
        <thead>
          <tr class="thinfo">
            <td>nom</td>
            {#each Object.entries(les_annees) as [keyAnnee]}
              <td>{keyAnnee}</td>
            {/each}
          </tr>
        </thead>
        <tbody>
          {#each Object.entries(elements) as [keyNom, keyValeurTabPrime]}
            <tr>
              <td class="col-md-3"> {keyNom}</td>
              {#each Object.entries(keyValeurTabPrime) as [index, valueAugmentation]}
                <td
                  class={valueAugmentation.SA_SALAIRE == 0 ? "vide" : ""}
                  style="background-color :{couleurAug(
                    valueAugmentation.SA_AUGMENTATION
                  )}"
                  >{valueAugmentation.SA_SALAIRE == 0
                    ? "-"
                    : new Intl.NumberFormat("fr-FR").format(
                        valueAugmentation.SA_SALAIRE
                      )}</td
                >
              {/each}
            </tr>
          {/each}
        </tbody>
      </table>
    </div>
  </div>
{/await}

<style>
  .table {
    font-size: 0.65em;
  }
  .vide {
    background-color: rgb(255, 255, 255);
  }
</style>
